import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generatePath } from 'react-router-dom';
import { Pagination, Response } from '@ui/src';
import { Device, DeviceSession } from '../../types';
import { individualCustomersApi } from '../services/individual';

import ROUTES from '../../../../routes';

export interface CustomerDevicesState {
  devices?: Device[];
  deviceSessions?: DeviceSession[];
  errorsList?: string;
  deviceSessionsPagination?: Pagination;
  pagination?: Pagination;
  takeCount?: number;
}

const initialState: CustomerDevicesState = {};

export const customerDevicesSlice = createSlice({
  name: 'customerDevices',
  initialState,
  reducers: {
    setTakeCount: (state, action: PayloadAction<number>) => {
      state.takeCount = action.payload;
    },
    clearDeviceState: (state) => {
      state.deviceSessions = undefined;
      state.deviceSessionsPagination = undefined;
    },
    clearDevicesState: (state) => {
      state.devices = undefined;
      state.pagination = undefined;
      state.takeCount = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualCustomersApi.endpoints.getCustomerDevices.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      individualCustomersApi.endpoints.getCustomerDevices.matchRejected,
      (state, action: any) => {
        state.devices = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      individualCustomersApi.endpoints.getCustomerDevices.matchFulfilled,
      (
        state,
        action: PayloadAction<Response<Device>> & {
          meta: { arg: { originalArgs: { id: string } } };
        },
      ) => {
        state.devices = action.payload.data.edges.map((item) => ({
          ...item.node,
          url: generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES_ITEM, {
            customerId: action.meta.arg.originalArgs.id,
            deviceId: item.node.id,
          }),
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      individualCustomersApi.endpoints.getCustomerDeviceSessions.matchFulfilled,
      (state, action: PayloadAction<Response<DeviceSession>>) => {
        state.deviceSessions = action?.payload?.data?.edges?.map(
          (item) => item.node,
        );

        state.deviceSessionsPagination = action.payload.data.pageInfo;
      },
    );
  },
});

export const { clearDevicesState, setTakeCount, clearDeviceState } =
  customerDevicesSlice.actions;

export default customerDevicesSlice.reducer;
